export default function Footer() {
  return (
    <footer
      className="relative"
      style={{
        backgroundColor: '#151414',
        color: '#fcfcfc',
        padding: '6vmax 5vmax 3vmax',
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-display text-lg" style={{ color: '#fcfcfc' }}>
                孔隙心理
              </span>
              <span style={{ color: 'rgba(252, 252, 252, 0.4)' }}>×</span>
              <span
                className="font-display text-lg"
                style={{ color: 'rgba(252, 252, 252, 0.6)' }}
              >
                有心AI
              </span>
            </div>
            <p
              className="mb-4 max-w-sm"
              style={{
                fontSize: '0.9rem',
                lineHeight: 1.6,
                color: 'rgba(252, 252, 252, 0.5)',
              }}
            >
              企业心理健康与效能提升解决方案。首创「社会心理服务事务所」模式，
              将AI技术嵌入日常沟通场景，用心理学深度确保效果，用陪伴的温度赢得信任。
            </p>
            <p
              style={{
                fontSize: '0.78rem',
                color: 'rgba(252, 252, 252, 0.3)',
              }}
            >
              上海孔隙心理咨询有限公司
            </p>
          </div>

          {/* Links */}
          <div>
            <p
              className="text-caption mb-4"
              style={{ color: 'rgba(252, 252, 252, 0.4)' }}
            >
              服务
            </p>
            <ul className="space-y-2">
              {['AI沟通引擎', '桌游式诊断', '主题工作坊', '持续护航服务'].map(
                (item) => (
                  <li key={item}>
                    <a
                      href="#showcase"
                      className="interactive transition-colors duration-300 hover:text-white"
                      style={{
                        fontSize: '0.9rem',
                        color: 'rgba(252, 252, 252, 0.5)',
                      }}
                    >
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <p
              className="text-caption mb-4"
              style={{ color: 'rgba(252, 252, 252, 0.4)' }}
            >
              联系
            </p>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://work.weixin.qq.com/kfid/kfcc1729b8642e445e3"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: '0.9rem',
                    color: 'rgba(252, 252, 252, 0.7)',
                    textDecoration: 'none',
                  }}
                >
                  在线客服
                </a>
              </li>
              <li
                style={{
                  fontSize: '0.9rem',
                  color: 'rgba(252, 252, 252, 0.5)',
                }}
              >
                合作咨询
              </li>
              <li
                style={{
                  fontSize: '0.9rem',
                  color: 'rgba(252, 252, 252, 0.5)',
                }}
              >
                企业EAP服务
              </li>
              <li
                style={{
                  fontSize: '0.9rem',
                  color: 'rgba(252, 252, 252, 0.5)',
                }}
              >
                学校心理服务
              </li>
            </ul>
          </div>

          {/* WeChat Official Accounts */}
          <div>
            <p
              className="text-caption mb-4"
              style={{ color: 'rgba(252, 252, 252, 0.4)' }}
            >
              关注我们
            </p>
            <div className="flex gap-4">
              <a
                href="https://work.weixin.qq.com/kfid/kfcc1729b8642e445e3"
                target="_blank"
                rel="noopener noreferrer"
                className="interactive flex flex-col items-center gap-1.5 transition-all duration-300 hover:opacity-100"
                style={{ opacity: 0.85, textDecoration: 'none' }}
              >
                <img
                  src="/images/gzh-kongxi.jpg"
                  alt="孔隙心理服务号"
                  style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '4px',
                  }}
                />
                <span
                  style={{
                    fontSize: '0.7rem',
                    color: 'rgba(252, 252, 252, 0.5)',
                  }}
                >
                  孔隙心理服务号
                </span>
              </a>
              <a
                href="https://work.weixin.qq.com/kfid/kfcc1729b8642e445e3"
                target="_blank"
                rel="noopener noreferrer"
                className="interactive flex flex-col items-center gap-1.5 transition-all duration-300 hover:opacity-100"
                style={{ opacity: 0.85, textDecoration: 'none' }}
              >
                <img
                  src="/images/gzh-youxinai.jpg"
                  alt="有心AI服务号"
                  style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '4px',
                  }}
                />
                <span
                  style={{
                    fontSize: '0.7rem',
                    color: 'rgba(252, 252, 252, 0.5)',
                  }}
                >
                  有心AI服务号
                </span>
              </a>
              <a
                href="https://work.weixin.qq.com/kfid/kfcc1729b8642e445e3"
                target="_blank"
                rel="noopener noreferrer"
                className="interactive flex flex-col items-center gap-1.5 transition-all duration-300 hover:opacity-100"
                style={{ opacity: 0.85, textDecoration: 'none' }}
              >
                <img
                  src="/images/customer-service-qr.png"
                  alt="企业微信客服"
                  style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '4px',
                  }}
                />
                <span
                  style={{
                    fontSize: '0.7rem',
                    color: 'rgba(252, 252, 252, 0.5)',
                  }}
                >
                  企业微信客服
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between pt-6 gap-4"
          style={{
            borderTop: '1px solid rgba(252, 252, 252, 0.08)',
          }}
        >
          <p
            style={{
              fontSize: '0.75rem',
              color: 'rgba(252, 252, 252, 0.3)',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            © 2026 孔隙心理 × 有心AI. All rights reserved.
          </p>
          <p
            style={{
              fontSize: '0.75rem',
              color: 'rgba(252, 252, 252, 0.3)',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            主动心理健康 =（科学|专业 + 与时俱进 + 人文关怀）× AI
          </p>
        </div>
      </div>
    </footer>
  );
}
